/*eslint-disable*/
import React from 'react';
// @mui/material components
import SubscriptionFormComponent from './SubscriptionForm';
export default function ValidationForms() {
  return <SubscriptionFormComponent />;
}
